import { BOM } from './lube/BOM';
import { openUrl, isNative, getEnv,getUrlStrs,isSimulatorEnv } from './utils.js';
import { config } from './config.js';
/*
* @type
* *
0 没有 1 success, 2 info, 3 error
* */
BOM.alert = function(msg, type = 3) {
    if (isNative()) {
        try {
            openUrl('local://toast?text=' + msg + '&type=' + type);
        } catch (e) {
            BOM.window.alert(msg);
        }
    } else {
        BOM.window.alert(msg);
    }
};
//跳转到线上异常页面
function showErrorPage(msg) {
    if(isSimulatorEnv()) return;
    BOM.window.location.href = config.WEBPROTOCOL + 'error?err_msg=' + encodeURIComponent(msg);
}

function setDefaultPageStyle() {
    const env = getEnv();
    if (!isNative() && (env === 'dev' || env === 'ssr')) {
        const params=getUrlStrs();
        if(!params.theme_name || params.theme_name==='Dark') {
            BOM.document.body.style.backgroundColor = 'rgba(0,0,0,0.75)';
        }else{
            BOM.document.body.style.backgroundColor = 'rgba(255,255,255)';
        }
    }
}

export { BOM, showErrorPage, setDefaultPageStyle };
